import { CommonModule } from '@angular/common';
import { TgBoxes2Module, TgGridModule } from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { PropertyInformationNoticeComponent } from './property-information-notice.component';

@NgModule({
    imports: [CommonModule, TgGridModule, TgBoxes2Module],
    declarations: [PropertyInformationNoticeComponent],
    exports: [PropertyInformationNoticeComponent]
})
export class PropertyInformationNoticeModule { }
